import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=1129db4a&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=1129db4a&lang=scss&scoped=true&"
import style1 from "./ProductCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1129db4a",
  null
  
)

export default component.exports